// removed by extract-text-webpack-plugin
module.exports = {"hero":"src-components----hero-module---hero---S__gH","heroImage":"src-components----hero-module---heroImage---DciWV","heroDetails":"src-components----hero-module---heroDetails---3uv8x","heroHeadline":"src-components----hero-module---heroHeadline---jhgHQ","heroTitle":"src-components----hero-module---heroTitle---2LulU"};


//////////////////
// WEBPACK FOOTER
// ./src/components/hero.module.css
// module id = 167
// module chunks = 35783957827783 107818501498521